export const CX_API_ADDRESS = "/v31"; //bosApiAddress
export const CX_V1_BETA_API_ADDRESS = "/cx/v1/beta"; //cxBetaApiAddress
export const HCPORTAL_V1_API_ADDRESS = "/hcportal/v1"; //bosHcPortalApiAddress
export const HCPORTAL_V1_PRACTICES_API_ADDRESS = `${HCPORTAL_V1_API_ADDRESS}/practices`; //bosHcPortalPracticesApiAddress
